import BaseCommand from "./baseCommand";

class ReOrderComponentInBodyCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
  }

  execute() {
    if (this.componentData.draggedFrom === "doc-component") {
      // if dragged from bodyview to bodyview

      const {
        layout,
        newRow,
        rowIndex,
        colIndex,
        draggedSection,
        updateComponentOrder,
        reOrderSectionListAction,
        dbRowIndex,
        dbColIndex,
        draggedRowIndex,
        draggedColumnIndex,
        updateDraggedSection,
      } = this.componentData;

      this.newLayout = JSON.parse(JSON.stringify(layout));

      this.isOldRowDelted = false;
      // add the element
      if (newRow) {
        this.newLayout.splice(rowIndex, 0, [draggedSection.id]);
      } else if (!newRow) {
        const rowIDs = JSON.parse(JSON.stringify(this.newLayout[rowIndex]));
        rowIDs.splice(colIndex, 0, draggedSection.id);
        this.newLayout[rowIndex] = rowIDs;
      }

      // remove old from layout
      let removeRowIndex = draggedRowIndex;
      let removeColIndex = draggedColumnIndex;

      if (newRow && rowIndex <= draggedRowIndex) {
        removeRowIndex += 1;
      } else if (
        draggedRowIndex === rowIndex &&
        colIndex < draggedColumnIndex
      ) {
        removeColIndex += 1;
      }
      if (this.newLayout[removeRowIndex].length === 1) {
        this.isOldRowDelted = true;
        this.newLayout.splice(removeRowIndex, 1);
      } else {
        this.newLayout[removeRowIndex].splice(removeColIndex, 1);
      }

      let newDbRowIndex = dbRowIndex;
      let newDbColIndex = dbColIndex;
      if (this.isOldRowDelted && rowIndex >= draggedRowIndex) {
        newDbRowIndex -= 1;
      } else if (
        draggedRowIndex === rowIndex &&
        colIndex > draggedColumnIndex
      ) {
        newDbColIndex -= 1;
      }

      const payload = {
        component: {
          ...draggedSection,
          row: newDbRowIndex,
          col: newDbColIndex,
          component_id: draggedSection.id,
        },
        new_row_added: newRow,
        is_deleted: false,
      };

      reOrderSectionListAction(this.newLayout);
      updateComponentOrder(payload).then(res => {
        this.oldDBIndex = res;
      });

      updateDraggedSection(null, null, null, null);
    } else {
      // handle draggeed form outside body
      console.error(
        "Cannot move component from ",
        this.componentData.draggedFrom,
        "to",
        this.componentData.draggedTo,
      );
    }
  }

  undo() {
    const {
      updateComponentOrder,
      reOrderSectionListAction,
      draggedSection,
      dbRowIndex,
      dbColIndex,
      layout,
    } = this.componentData;
    const payload = {
      component: {
        ...draggedSection,
        row: this.oldDBIndex.row,
        col: this.oldDBIndex.col,
        component_id: draggedSection.id,
      },
      new_row_added: this.isOldRowDelted,
      is_deleted: false,
      old_loc: {
        row: dbRowIndex,
        col: dbColIndex,
      },
    };

    updateComponentOrder(payload).then(() => {
      reOrderSectionListAction(layout);
    });
  }
}

export default ReOrderComponentInBodyCommand;



// WEBPACK FOOTER //
// ./src/commands/reOrderComponentInBodyCommand.js